import { combineReducers } from 'redux';
import { aggregatedStatsReducer } from './reducers/aggregated-stats-reducer';
import { chartsReducer } from './reducers/charts-reducer';

export default combineReducers({
  aggregatedStatsReducer,
  chartsReducer,
});
